import type { IconType } from 'react-icons';
import { TbDeviceMobile, TbMail, TbMessage } from 'react-icons/tb';

export type TwoFactorMethodKey = 'email' | 'totp' | 'sms';

export const TWO_FACTOR_ROWS: {
  key: TwoFactorMethodKey;
  icon: IconType;
  title: string;
  sub: string;
}[] = [
  { key: 'email', icon: TbMail, title: 'Email', sub: 'Get a code by email at sign-in.' },
  {
    key: 'totp',
    icon: TbDeviceMobile,
    title: 'Authenticator App',
    sub: 'Use Google Authenticator, Authy, etc.',
  },
  { key: 'sms', icon: TbMessage, title: 'Mobile (SMS)', sub: 'Get a code by text message.' },
];
